import axios from "axios";
import { PRODUCTS_URL } from "../../../../../constants/config";
import {
  PURCHASE_ORDER_URL,
  PURCHASE_ORDER_V2_URL,
  SUPPLIER_PURCHASE_ORDER_BY_ID,
  LAST3POS,
  PURCHASE_ORDER_V2_BULK_INVOICE_PAY,
  SEND_PO_INVOICE_EMAIL_URL,
  SEND_PURCHASE_RECIEVE_INVOICE_EMAIL_URL,
  SEND_PURCHASE_RETURN_INVOICE_EMAIL_URL,
  AI_QUANTITY_SUGGESTIONS_URL,
  AI_QUANTITY_SUGGESTIONS_PO_URL,
} from "../../../../../constants/config";
import { checkBackgroundTaskStatus } from "../../../Common/backgroundTaskStatus";

export function findProducts(queryParams) {
  return axios.get(
    `${PRODUCTS_URL}/list3?is_group=${queryParams.is_group || 0}&supplier_ids=${
      queryParams.supplier_id || ""
    }&search_key=${queryParams?.searchKey?.trimLeft() || queryParams?.search_key?.trimLeft() || ""}&page=${
      queryParams.pageNumber || ""
    }&is_archived=${queryParams.is_archived}&page_size=${queryParams.pageSize || 50}&sort_by=name&sort_in=asc&channel_id=${queryParams.channel_id || ""}&show_stocks=${queryParams.show_stocks||0}&scan_mode=${queryParams.scan_mode || 0}`
  );
}

export function optimizedFindProducts(params) {
  return axios.get(`${PRODUCTS_URL}/list3`, { params });
}

// not use
export function createOrder(purchaseOrder) {
  return axios.post(`${PURCHASE_ORDER_URL}`, purchaseOrder);
}

// using
export function createV2Order(purchaseOrder) {
  return axios.post(`${PURCHASE_ORDER_V2_URL}`, purchaseOrder);
}

export function prevSupplyPrices(payload) {
  return axios.post(`${prevSupplyPrices}`, payload);
}

export function lastThreePos(id, channel_id) {
  return axios.get(`${LAST3POS}/recent?product_id=${id}&channel_id=${channel_id}`);
}

export function getProductAvgCost(payload) {
  return axios.post(`${LAST3POS}/product-avg-cost`, payload);
}

export function updateOrder(order) {
  return axios.put(`${PURCHASE_ORDER_V2_URL}/${order.id}`, order);
}

export function getSinglePurchaseOrder(id) {
  let _id = typeof id == "object" ? id.id : id || "";
  return axios.get(`${PURCHASE_ORDER_V2_URL}/${_id}?include_payments=${true}`);
}

export function getSinglePurchaseReceive(id) {
  let _id = typeof id == "object" ? id.id : id || "";
  return axios.get(`${SUPPLIER_PURCHASE_ORDER_BY_ID}/${_id}`);
}

// Pay Invoice Purchase Order
export function bulkPayOrder(payload) {
  const obj = payload.po_split_info;
  Object.keys(obj).forEach((key) => {
    if (obj[key] === 0) {
      delete obj[key];
    }
  });
  return axios.post(`${PURCHASE_ORDER_V2_BULK_INVOICE_PAY}`, { ...payload });
}

// Send PO Email
export function sendPOEmail(payload) {
  return axios.post(`${SEND_PO_INVOICE_EMAIL_URL}`, payload);
}

export function sendPurchaseReceiveEmail(payload) {
  return axios.post(`${SEND_PURCHASE_RECIEVE_INVOICE_EMAIL_URL}`, payload);
}

// send purchase return email
export function sendPurchaseReturnEmail(payload) {
  return axios.post(`${SEND_PURCHASE_RETURN_INVOICE_EMAIL_URL}`, payload);
}

// New function for AI quantity suggestions
export function generateAIQuantitySuggestions(payload) {
  return axios.post(`${AI_QUANTITY_SUGGESTIONS_URL}`, payload);
}

export function generateAIQuantitySuggestionsPO(payload) {
  return axios.post(`${AI_QUANTITY_SUGGESTIONS_PO_URL}`, payload);
}

// New function for AI-powered PO background task
export function createAIPoweredPOBackground(payload) {
  return axios.post(`${AI_QUANTITY_SUGGESTIONS_PO_URL}`, payload);
}

// New function to get AI PO task status
//export function getAIPOTaskStatus(taskId) {
//  return axios.get(`${AI_QUANTITY_SUGGESTIONS_PO_URL}/status/${taskId}`);
//}

// New function to get AI PO task status
export function getAIPOTaskStatus(taskId) {
  return checkBackgroundTaskStatus(taskId);
}
